import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  makeStyles,
  TablePagination,
  TableSortLabel,
} from "@material-ui/core";

import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  table: {
    marginTop: theme.spacing(0),
    "& thead th": {
      fontWeight: "600",
      color: "white",
      backgroundColor: "#AF83B7",
    },
    "& tbody td": {
      fontWeight: "300",
    },
    "& tbody tr:hover": {
      backgroundColor: "#fffbf2",
      cursor: "pointer",
    },
  },
}));

export default function useDistributionGradesTable(records, headCells, filterFn) {
  const classes = useStyles();

  const pages = [5, 10, 25];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const TblRecommendationContainer = (props) => (
    <Table className={classes.table}>{props.children}</Table>
  );

  const TblRecommendationHead = (props) => {
    const handleSortRequest = (cellId) => {
      const isAsc = orderBy === cellId && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(cellId);
    };

    return (
      <TableHead>
        <TableRow style={{ width: "1000px",height:"80px" }}>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              style={{ textAlign: "center",padding:"0px",borderRight: "1px solid lightgray" }}
            >
              { headCell && headCell.label.length > 2 ? (
                <p style={{ transform: "rotate(-60deg)", fontSize: "12px" }}>
              
                  {headCell.label}
                </p>
              ) : (
                <p style={{ fontSize: "12px" }}> {headCell.label}</p>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const TblPagination = () => (
    <TablePagination
      component="div"
      page={page}
      rowsPerPageOptions={pages}
      rowsPerPage={rowsPerPage}
      count={records.length}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
    />
  );

  // function stableSort(array, comparator) {
  //     const stabilizedThis = array.map((el, index) => [el, index]);
  //     stabilizedThis.sort((a, b) => {
  //         const order = comparator(a[0], b[0]);
  //         if (order !== 0) return order;
  //         return a[1] - b[1];
  //     });
  //     return stabilizedThis.map((el) => el[0]);
  // }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const recordsAfterPagingAndSorting = () => {
    // return stableSort(filterFn.fn(records), getComparator(order, orderBy))
    //     .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
  };

  return {
    TblRecommendationContainer,
    TblRecommendationHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  };
}
